import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// DS: hover do card faz lift sutil (translateY + shadow + border).
// Light mode: shadow-2 sutil. Dark mode: shadow já vem da regra global ds-card-elevated.
const card = cva('rounded-lg border border-border bg-elevated transition-all', {
  variants: {
    padding: {
      none: '',
      sm: 'p-3',
      md: 'p-4',
      lg: 'p-6',
    },
    hover: {
      true: 'hover:border-border2 hover:shadow-[0_2px_8px_rgba(0,0,0,0.06)] hover:-translate-y-px',
      false: '',
    },
  },
  defaultVariants: { padding: 'md', hover: false },
});

export interface CardProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof card> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { padding, hover, className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn(card({ padding, hover }), className)} {...rest} />;
});

export function CardTitle({ className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={cn('text-xs font-semibold uppercase tracking-wider text-text-muted', className)}
      {...rest}
    />
  );
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('text-sm text-text-2', className)} {...rest} />;
}
